import { AUDITS_FIELDS } from 'constants/global';
import AuditCardDataValue from './AuditCardDataValue';
import AuditCardDateValue from './AuditCardDateValue';
import AuditCardGeoValue from './AuditCardGeoValue';
import AuditCardListValue from './AuditCardListValue';

export const AUDIT_DRAWER_FIELDS = [
	{
		id: AUDITS_FIELDS.data,
		Component: AuditCardDataValue,
		// because data is collapsable - we want it to have constant width
		valueSx: { width: '90%' }
	},
	{
		id: AUDITS_FIELDS.userId
	},
	{
		id: AUDITS_FIELDS.action
	},
	{
		id: AUDITS_FIELDS.occurred,
		Component: AuditCardDateValue
	},
	{
		id: AUDITS_FIELDS.device
	},
	{
		id: AUDITS_FIELDS.method
	},
	{
		id: AUDITS_FIELDS.remoteAddress
	},
	{
		id: AUDITS_FIELDS.externalIDs,
		Component: AuditCardListValue
	},
	{
		id: AUDITS_FIELDS.geo,
		Component: AuditCardGeoValue
	}
];
